import * as consts from "src/helpers";
import * as Yup from 'yup';

export interface IProjectEnquiryRequestForm {
    projectSize: string;
    projectType: string;
    serviceName: string;
    state: string;
    projectCategoryType: string;
    projectLocation: string;
    nearestCity: string;
    distanceFromNearestCity: string;
    nearestAirport: string;
    nearestRailwayStation: string;
    customerType: string;
    orderType: string;
    channelPartnerId: string | null; // Assuming ObjectId is represented as a string
    imageAttachments: string[] | null;
    project_description?: string; // Optional field
}


export const PROJECT_ENQUIRY_REQUEST_FORM_INIT: IProjectEnquiryRequestForm = {
    serviceName: "",
    customerType: "",
    projectCategoryType: "",
    projectType: "",
    projectSize: "",
    projectLocation: "",
    state: "",
    nearestCity: "",
    distanceFromNearestCity: "",
    nearestAirport: "",
    nearestRailwayStation: "",
    orderType: "",
    channelPartnerId: "",
    imageAttachments: [],
    project_description: ""
};



export const PROJECT_ENQUIRY_REQUEST_FORM_FIELDS: consts.FormField[] = [
    {
        label: 'Project Size',
        dataKey: 'projectSize',
        componentType: 'input',
        componentProps: {
            type: "number",
            placeholder: 'Project Size',
            numberFormatted: true,
            options: consts.PROJECT_UNITS_OPTIONS,
            defaultSelectedInputOption: "MW",
            required: true
        },
    },

    {
        label: 'Project Type',
        dataKey: 'projectType',
        componentType: 'options',
        componentProps: {
            options: consts.PROJECT_TYPES,
            required: true
        },
    },
    {
        label: 'Service Name',
        dataKey: 'serviceName',
        componentType: 'input',
        componentProps: {
            type: "text",
            placeholder: 'Service Name',
            required: true
        },
    },
    {
        label: 'Customer Type',
        dataKey: 'customerType',
        componentType: 'options',
        componentProps: {
            options: consts.CUSTOMER_TYPE_OPTIONS,
            required: true
        },
    },
    {
        label: 'Project Category Type',
        dataKey: 'projectCategoryType',
        componentType: 'options',
        componentProps: {
            options: [],
            required: true
        },
    },
    {
        label: 'Order Type',
        dataKey: 'orderType',
        componentType: 'options',
        componentProps: {
            options: consts.PROJECT_GENERAL_PROJECT_ORDER_TYPE_OPTIONS,
            required: true
        },
    },
    // {
    //     label: 'Select Channel Partner',
    //     dataKey: 'channelPartnerId',
    //     componentType: 'options',
    //     componentProps: {
    //         options: [],
    //         required: true
    //     },
    // },
    {
        label: 'Project Location',
        dataKey: 'projectLocation',
        componentType: 'input',
        componentProps: {
            type: "text",
            placeholder: 'Project Location',
            required: true
        },
    },
    {
        label: 'State',
        dataKey: 'state',
        componentType: 'options',
        componentProps: {
            options: consts.STATES_OPTIONS,
            required: true
        },
    },
    {
        label: 'Nearest City',
        dataKey: 'nearestCity',
        componentType: 'input',
        componentProps: {
            type: "text",
            placeholder: 'Nearest City',
            required: true
        },
    },
    {
        label: 'Distance From Nearest City',
        dataKey: 'distanceFromNearestCity',
        componentType: 'input',
        componentProps: {
            type: "number",
            regex: consts.NUMBER_REGEX,
            numberFormatted: true,
            placeholder: 'Distance From Nearest City',
            options: consts.DISTANCE_UNITS_OPTIONS,
            defaultSelectedInputOption: "km",
            required: true
        },
    },
    {
        label: 'Nearest Airport',
        dataKey: 'nearestAirport',
        componentType: 'input',
        componentProps: {
            type: "text",
            placeholder: 'Nearest Airport',
            required: true
        },
    },
    {
        label: 'Nearest Railway Station',
        dataKey: 'nearestRailwayStation',
        componentType: 'input',
        componentProps: {
            type: "text",
            placeholder: 'Nearest Railway Station',
            required: true
        },
    },
    {
        label: 'Images',
        dataKey: 'imageAttachments',
        componentType: 'file_picker',
        componentProps: {
            fileSelectionType: 'multi',
            required: true,
        },
    },
    {
        label: 'Project Description',
        dataKey: 'project_description',
        componentType: 'textarea',
        componentProps: {
            required: true,
        }
    }
];


export const PROJECT_ENQUIRY_REQUEST_FORM_VALIDATION_SCHEMA = Yup.object().shape({
    projectSize: Yup.string().required('Project size is required'),
    projectType: Yup.string().required('Project type is required'),
    serviceName: Yup.string().required('Service name is required'),
    state: Yup.string().required('State is required'),
    projectCategoryType: Yup.string().required('Project category type is required'),
    projectLocation: Yup.string().required('Project location is required'),
    nearestCity: Yup.string().required('Nearest city is required'),
    distanceFromNearestCity: Yup.string().required('Distance from nearest city is required'),
    nearestAirport: Yup.string().required('Nearest airport is required'),
    nearestRailwayStation: Yup.string().required('Nearest railway station is required'),
    customerType: Yup.string().required('Customer type is required'),
    orderType: Yup.string().required('Order type is required'),
    // channelPartnerId: Yup.string().nullable(),
    imageAttachments: Yup.array().of(Yup.mixed().test('fileType', 'Only JPG, JPEG, and PNG formats are allowed', (value) => {
        // Check if the value is a string (URL or path)
        if (typeof value === 'string') {
            return true; // Accept string values
        }
        // Check if the value is a File object
        if (value instanceof File) {
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            return validTypes.includes(value.type); // Validate file type
        }
        return false; // Reject if it's neither a string nor a valid file
    })).nullable(),
    project_description: Yup.string().optional(),
});